/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import { RackAddEditSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import SelectInput from '../../Input/SelectInput'
import TextField from '../../Input/TextInput'

const racks = [
  { id: 'rack', name: 'Selective' },
  { id: 'shelving', name: 'Shelving' },
  { id: 'ground', name: 'Ground Floor' },
  { id: 'double', name: 'Double Deep' }
]

function ModalUpdateRack(props) {
  const [areas, setAreas] = useState([])
  const { warehouseId } = props
  const [loading, setLoading] = useState(true)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const RackId = props.id
  const [hasData, setHasData] = useState({
    rack_name: '',
    area_id: '',
    category_id: [],
    type: '',
    total_beam: '',
    total_level: '',
    total_slot: ''
  })

  useEffect(() => {
    if (props.show && RackId !== 0) {
      loadData(RackId)
    }
    if (props.show && warehouseId?.warehouseId) {
      loadArea()
    }
  }, [RackId, props.show, warehouseId])

  const loadData = async (RackId) => {
    try {
      setLoading(true)
      const response = await api.get(`master/racks/${RackId}`)
      const responses = response.data.data
      const ctg = responses.categories
      setHasData({
        rack_name: responses.name,
        area_id: responses.area_id,
        category_id: ctg.map((item) => ({
          id: item.id,
          name: item.name
        })),
        type: responses.type,
        total_beam: responses.total_beam,
        total_level: responses.total_level,
        total_slot: responses.total_slot
      })
      setLoading(false)
    } catch (err) {
      setLoading(false)
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const handleSubmit = async (values, actions) => {
    try {
      setLoadingSubmit(true)
      const payload = {
        ...values,
        total_beam: Number(values.total_beam),
        total_level: Number(values.total_level),
        total_slot: Number(values.total_slot)
      }
      const response = await api.post(`/master/racks/${RackId}`, payload)
      if (response.data.success) {
        props.refreshData()
        loadData(RackId)
        props.onHide()
        Common.showPopUpSuccessMessage(response.data.message)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'

      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  const loadArea = async () => {
    try {
      const res = await api.get(
        `/master/area/all?id=${warehouseId.warehouseId}`
      )
      setAreas(res.data.data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  return (
    <Modal {...props} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Update Rack</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-warning" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        {!loading && (
          <Formik
            initialValues={{
              rack_name: hasData.rack_name,
              total_beam: hasData.total_beam,
              total_level: hasData.total_level,
              area_id: hasData.area_id,
              type: hasData.type,
              category_id: hasData.category_id,
              total_slot: hasData.total_slot ? String(hasData.total_slot) : ''
            }}
            enableReinitialize={true}
            validationSchema={RackAddEditSchema}
            validateOnChange={true}
            validateOnBlur={true}
            validate={(values) => {
              const errors = {}
              if (parseInt(values.total_beam) < parseInt(hasData.total_beam)) {
                errors.total_beam = `Total beam must be at least ${hasData.total_beam}`
              }
              if (
                parseInt(values.total_level) < parseInt(hasData.total_level)
              ) {
                errors.total_level = `Total level must be at least ${hasData.total_level}`
              }
              if (
                values.type !== 'ground' &&
                parseInt(values.total_slot) < parseInt(hasData.total_slot)
              ) {
                errors.total_slot = `Total slot must be at least ${hasData.total_slot}`
              }
              return errors
            }}
            onSubmit={(values) => {
              handleSubmit(values)
            }}
          >
            {({
              handleBlur,
              handleSubmit,
              handleChange,
              values,
              errors,
              isValid,
              dirty,
              setFieldValue,
              touched
            }) => {
              return (
                <Form className="d-grid gap-2" onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <TextField
                        label="name"
                        name="rack_name"
                        value={values.rack_name}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        required={true}
                        disabled={true}
                        styles={{ height: '45px' }}
                      />
                    </Col>
                    <Col md={4}>
                      <TextField
                        label="total beam"
                        name="total_beam"
                        value={values.total_beam}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        required={true}
                        disabled={values.type === 'ground'}
                        min={hasData.total_beam}
                        styles={{ height: '45px' }}
                      />
                    </Col>
                    <Col md={4}>
                      <TextField
                        label="total level"
                        name="total_level"
                        value={values.total_level}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        required={true}
                        disabled={values.type === 'ground'}
                        min={hasData.total_level}
                        styles={{ height: '45px' }}
                      />
                    </Col>
                    <Col md={4}>
                      <SelectInput
                        label="slot/beam"
                        name="total_slot"
                        id="total_slot"
                        value={values.total_slot}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        options={
                          values.type === 'ground'
                            ? [{ id: '1', name: '1' }]
                            : [
                                ...[
                                  { id: '2', name: '2' },
                                  { id: '3', name: '3' },
                                  { id: '4', name: '4' }
                                ].filter(
                                  (item) =>
                                    parseInt(item.id) >= hasData.total_slot
                                )
                              ]
                        }
                        styles={{ height: '45px' }}
                        required={true}
                        disabled={values.type === 'ground'}
                      />
                    </Col>
                    <Col md={6}>
                      <SelectInput
                        label="area"
                        name="area_id"
                        id="area_id"
                        value={values.area_id}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        options={areas}
                        required={true}
                        disabled={true}
                        styles={{ height: '45px' }}
                      />
                    </Col>
                    <Col md={6}>
                      <SelectInput
                        label="type"
                        name="type"
                        id="type"
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        options={racks}
                        handleChange={(e) => {
                          setFieldValue('type', e.target.value)
                          if (e.target.value === 'ground') {
                            setFieldValue('total_beam', 1)
                            setFieldValue('total_level', 1)
                          } else {
                            setFieldValue('total_beam', values.total_beam ?? '')
                            setFieldValue(
                              'total_level',
                              values.total_level ?? ''
                            )
                          }
                          setHasData({ ...hasData, type: e.target.value })
                        }}
                        value={values.type}
                        required={true}
                        disabled={true}
                        styles={{ height: '45px' }}
                      />
                    </Col>
                  </Row>
                  <Modal.Footer className="mt-3">
                    <CustomCloseButton onClick={props.onHide} />
                    <CustomButton
                      onClick={handleSubmit}
                      variant={
                        !isValid || !dirty || loadingSubmit
                          ? 'secondary'
                          : 'warning'
                      }
                      disabled={!isValid || !dirty || loadingSubmit}
                      text={!loadingSubmit ? 'Update' : 'Loading...'}
                      classNameValue={`text-white ${
                        !isValid || !dirty || loadingSubmit ? 'opacity-25' : ''
                      }`}
                    />
                  </Modal.Footer>
                </Form>
              )
            }}
          </Formik>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ModalUpdateRack
